import { type DecisionStage } from "@portal/api/decisioning";
import { useFetchDecisioningEnabled } from "@portal/api/decisioning/admin";
import { useFlags } from "@portal/providers/GlobalFlagsProvider";
import { useSearchParams } from "react-router-dom";
import { LOG_DECISION_PARAM } from "./panel/DecisioningPanelContext";

type NudgeStage = Extract<DecisionStage, "approve" | "decline" | "close">;

const NUDGE_MESSAGES: Record<NudgeStage, string> = {
	approve: "Log this approval?",
	decline: "Log this decline?",
	close: "Log this closure?",
};

/** After a real approve/decline/close, offers to record the matching decision in the decisioning tool. */
export const useLogDecisionNudge = () => {
	const { decisioningEnabled } = useFetchDecisioningEnabled();
	const { showInfoFlag } = useFlags();
	const [, setSearchParams] = useSearchParams();

	return (stage: NudgeStage) => {
		if (!decisioningEnabled) return;
		showInfoFlag({
			message: NUDGE_MESSAGES[stage],
			actions: [
				{
					label: "Log decision",
					actionId: `log-decision-${stage}`,
					onClick: () =>
						setSearchParams((prev) => {
							const next = new URLSearchParams(prev);
							next.set("adminTool", "decisioning");
							next.set(LOG_DECISION_PARAM, stage);
							return next;
						}),
				},
			],
		});
	};
};
